<template>
    <div>
		<!-- Explain App button -->
		<!-- <div class="row justify-content-end m-3">
			<div class="d-none d-md-block">
				<button class="btn btn-primary" data-toggle="modal" data-target="#explainAppModal">App gì đây?</button>
			</div>
		</div>
		<ExplainAppModal id="explainAppModal" /> -->

		<!-- Inputs -->
        <div class="row my-2 pl-0 pl-md-5">
            <label class="col-12 col-md-3">
                Token Code:
                <el-tooltip content="Token code cần thiết để lấy thông tin Điểm rèn luyện, xin hãy làm theo các bước hướng dẫn để lấy token code">
                    <small class="mx-1"><router-link :to="{ name: 'DRLHowTo' }" :target="dataFetched() ? '_blank' : ''">(Cách lấy Token)</router-link></small>
                </el-tooltip>
            </label>
            <input v-model="tokenCode" class="form-control col-11 col-md-6 mx-3" />
        </div>
        <div class="row my-2 pl-0 pl-md-5">
            <label class="col-12 col-md-3">Mã Sinh viên:</label>
            <input v-model="userCode" @keypress.enter="getData()" class="form-control col-11 col-md-6 mx-3" />
        </div>
        <div class="row my-2 pl-0 pl-md-5 justify-content-center">
            <button class="btn btn-outline-primary" @click="getData()">Tìm hoạt động</button>
        </div>

        <QuickTutorial :allCriterias="allCriterias" />

		<!-- Outputs -->
        <div v-if="!isLoading">
			<!-- Activites -->
            <div v-if="activities.length != 0" class="row my-5">

                <h4 class="col-12">HOẠT ĐỘNG:</h4>
                <small class="col-12">(Click để xếp Hoạt động, còn {{ activities.filter(act => !act.userPoint).length }} chưa xếp)</small>

                <div class="col-12">
                    <div v-for="act in activities" :key="act.id" class="my-3">
                        <div v-if="!act.userPoint">

                            <div @click="chooseAct(act)" class="cursor-pointer activity-panel row" :class="{ 'text-success active': choosingAct.AId == act.AId }">

                                <span class="col-12 col-md-11">
                                        <div class="dot-dot-dot" :title="act.AName">{{ act.AName }} </div>
                                </span>
                                <span class="text-primary">({{ act.CriteriaLst.length }} tiêu chí)</span>

                                <span @click.stop="act.showCrite = !act.showCrite; $forceUpdate()" class="ml-1">
                                    <i v-if="act.showCrite" class="fas fa-chevron-circle-up"></i>
                                    <i v-else class="fas fa-chevron-circle-down"></i>
                                </span>
                            </div>

                            <div v-if="act.showCrite" class="ml-3">
                                <div v-for="crite in act.CriteriaLst" :key="crite.CId">
                                    + {{ crite.CName }}
                                    <span class="text-primary">({{ crite.CMaxPoint }}đ)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

			<!-- Criterias -->
            <div id="criterias-container" v-if="allCriterias.length != 0">
                <div class="row justify-content-between">
                    <h4 class="mx-1 my-3">TIÊU CHÍ:</h4>
                    <div class="my-3">
                        <div class="btn-group btn-group-sm mx-3" role="group">
                            <button class="btn btn-outline-primary" style="pointer-events: none;">Tự động chấm</button>
                            <el-tooltip content="Thuật toán tham lam, hoạt động nào điểm cao thì xếp vào trước">
                                <button @click="autoPut()" class="btn btn-outline-primary">Cách 1</button>
                            </el-tooltip>
                            <el-tooltip content="Thuật toán duyệt toàn bộ, thử mọi trường hợp">
                                <button @click="bruteforcePut()" class="btn btn-outline-primary">Cách 2</button>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <div class="row mx-1 mb-3">
					<small class="text-danger">CHÚ Ý: Nếu Điểm tự chấm lớn hơn Điểm tối đa thì chỉ lưu được Điểm tối đa. VD: (33/30đ) Điểm học tập, sẽ chỉ lưu 30đ thay vì 33đ</small>
                </div>

                <div class="row my-2 pl-3 pl-md-5">
					<!-- A Criteria Group -->
                    <div class="col-6 col-lg-3 border-right mb-3" v-for="(criteriaGroup, i0) in allCriterias" :key="criteriaGroup.CTId">
                        <div class="overflow-auto">
                            <div>
                                <el-tooltip
                                    manual
                                    :content="criteriaGroup.CTPoint > criteriaGroup.CTMaxPoint ? 'Tiêu chí này tối đa chỉ '+ criteriaGroup.CTMaxPoint +' điểm' : criteriaGroup.CTName"
                                    v-model="tooltip[criteriaGroup.CTName]"
                                    @mouseenter.native="tooltipEnter(criteriaGroup.CTName)"
                                    @mouseleave.native="tooltipLeave(criteriaGroup.CTName)"
                                >
                                    <h4 class="dot-dot-dot border-bottom">
                                        <span :class="{ 'text-danger': criteriaGroup.CTPoint > criteriaGroup.CTMaxPoint }">
                                            ({{ criteriaGroup.CTPoint }}/{{ criteriaGroup.CTMaxPoint }}đ)
                                        </span>
                                        {{ criteriaGroup.CTName }}
                                    </h4>
                                </el-tooltip>

								<!-- A Criteria List -->
                                <div class="ml-3" v-for="(criteriaList, i1) in criteriaGroup.CriteriaGroupDetailsLst" :key="criteriaList.CGId">
                                    <el-tooltip
                                        manual
                                        :content="criteriaList.CGPoint > criteriaList.CGMaxPoint ? 'Tiêu chí này tối đa chỉ '+ criteriaList.CGMaxPoint +' điểm' : criteriaList.CGName"
                                        v-model="tooltip[criteriaList.CGName]"
                                        @mouseenter.native="tooltipEnter(criteriaList.CGName)"
                                        @mouseleave.native="tooltipLeave(criteriaList.CGName)"
                                    >
                                        <div class="dot-dot-dot text-primary">
                                            <span :class="{ 'text-danger': criteriaList.CGPoint > criteriaList.CGMaxPoint }">
                                                ({{ criteriaList.CGPoint }}/{{ criteriaList.CGMaxPoint }})
                                            </span>
                                            {{ criteriaList.CGName }}
                                        </div>
                                    </el-tooltip>

									<!-- A Criteria -->
                                    <div class="ml-3" v-for="crite in criteriaList.UserCriteriaDetailsLst" :key="crite.CId">
                                        <div v-if="crite.Proof">
                                                <div @click="chooseCrite(crite, [i0, i1])"
                                                    :class="{
														'cursor-pointer border': canChooseCrite(crite),
														'text-secondary': isCriteTaken(crite),
														'text-success': chosenActHasCrite(crite),
														'text-warning': hasHoveringAct(crite),
													}"
                                                    class="dot-dot-dot my-1" :title="crite.CName">
                                                        ({{ crite.UCPoint }}/{{ crite.CMaxPoint }})
                                                        {{ crite.CName }}
                                                </div>

											<!-- Criteatia's Matched Activity -->
                                            <el-tooltip
                                                manual
                                                effect="light"
                                                v-if="crite.UserCriteriaActivityLst[0]"
                                                v-model="tooltip[crite.UserCriteriaActivityLst[0].AName]"
                                                @mouseenter.native="tooltipEnter(crite.UserCriteriaActivityLst[0].AName, 1000)"
                                                @mouseleave.native="tooltipLeave(crite.UserCriteriaActivityLst[0].AName)"
                                            >
                                                <div slot="content">
                                                    <h5 class="text-center">{{ crite.UserCriteriaActivityLst[0].AName }} (ID: {{ crite.UserCriteriaActivityLst[0].AId }})</h5>
                                                    <div>Tiêu chí:</div>
													<!-- Other Criterias of this Activity -->
                                                    <div class="ml-2" v-for="actCrite in crite.UserCriteriaActivityLst[0].CriteriaLst" :key="actCrite.CId">
                                                        ({{ actCrite.CMaxPoint }}đ) {{ actCrite.CName }}
                                                    </div>
                                                </div>
                                                <div class="ml-3 dot-dot-dot text-secondary">
                                                    <span @click="unchooseAct(crite, [i0, i1])" class="text-danger cursor-pointer ml-1"><i class="fas fa-minus-circle"></i></span>
													<span @mouseenter="hoveringAct = crite.UserCriteriaActivityLst[0]" @mouseleave="hoveringAct = null" class="cursor-pointer">
                                                    	{{ crite.UserCriteriaActivityLst[0].AName }}
													</span>
                                                </div>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>

                <button v-if="hasChange" class="btn btn-primary submit" @click="submit()">
                    <i class="fas fa-save"></i> (Điểm tự chấm: {{ sum }}đ)
                </button>
            </div>
        </div>

        <div v-else>
            <div class="row my-2 pl-3 pl-md-5 justify-content-center">
                Đang tải dữ liệu
                <div class="mx-1">

                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div class="spinner-grow spinner-grow-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-5">
            <h4 class="col-12">Có thể bạn quan tâm:</h4>
            <div class="col-12">
                <router-link to="/time-table" :target="dataFetched() ? '_blank' : ''"><i class="fas fa-calendar-alt mr-2"></i>App xếp Lịch học</router-link>
            </div>
            <div class="col-12">
                <a href="https://www.facebook.com/groups/hotrosinhvienontapdaicuong/posts/888877058457995/" :target="dataFetched() ? '_blank' : ''">
                    <i class="fab fa-facebook mr-1"></i>Feedback của Người dùng
                </a>
            </div>
            <div class="col-12">
                <a href="https://www.facebook.com/hieupham19072001/" :target="dataFetched() ? '_blank' : ''"><i class="fab fa-facebook mr-1"></i>Phạm Trung Hiếu ?</a>
            </div>
        </div>
        <br>

		<!-- Drawer -->
        <el-tooltip content="Chọn Hoạt động">
            <button class="drawer-button" @click="drawer = true">
                <i class="fas fa-angle-right"></i>
            </button>
        </el-tooltip>

        <el-drawer
            size="50%"
            title="Chọn Hoạt động"
            :visible.sync="drawer"
            :direction="'ltr'"
        >
            <div class="col-12">
                <div v-for="act in activities" :key="act.id" class="my-3">
                    <div v-if="!act.userPoint">
                        <div @click="chooseAct(act)" class="cursor-pointer activity-panel row" :class="{ 'text-success active': choosingAct.AId == act.AId }">
                            <span class="col-12 col-md-11">
                                <div class="dot-dot-dot">{{ act.AName }} </div>
                            </span>
                            <span class="text-primary">({{ act.CriteriaLst.length }} tiêu chí)</span>
                            <span @click.stop="act.showCrite = !act.showCrite; $forceUpdate()" class="ml-1">
                                <i v-if="act.showCrite" class="fas fa-chevron-circle-up"></i>
                                <i v-else class="fas fa-chevron-circle-down"></i>
                            </span>
                        </div>

                        <div v-if="act.showCrite" class="ml-3">
                            <div v-for="crite in act.CriteriaLst" :key="crite.CId">
                                + {{ crite.CName }}
                                <span class="text-primary">({{ crite.CMaxPoint }}đ)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { setCookie, getCookie } from '@/utils/cookie.js'
import ExplainAppModal from './ExplainAppModal.vue'
import QuickTutorial from './QuickTutorial.vue'

export default {
	components: {
		ExplainAppModal,
		QuickTutorial,
	},
    data(){
        return {
            tokenCode: '',
            userCode: '',
            semester: '2021-1',
            allCriterias: [],
            criterias: [],
            activities: [],
            choosingAct: {},
            isLoading: false,
            hasChange: false,
            sum: 0,
            tooltip: {},
            tooltipTimeout: {},
            allCriteriasSnapshot: "[]",
            actsSnapshot: "[]",
            drawer: false,
			findingCriteriaCId: 0,
			hoveringAct: null,
        }
    },
    methods:{
        async getData(){
            try{
                if(this.tokenCode == '') return this.$toast.error('Chưa có Token Code!')
                if(this.userCode  == '') return this.$toast.error('Chưa có Mã sinh viên!')
                if(this.isLoading) return
                this.isLoading = true
                this.$loading()

                let response = await this.getSemester()
                if(response.data.RespCode != 0){
                    this.isLoading = false
                    this.$loading().close()
                    if(response.data.RespCode == 104) this.$toast.error('Token Code hoặc Mã Sinh viên không đúng, vui lòng nhập lại.')
                    else this.$toast.error(response.data.RespText)
                    return
                }

                this.semester = response.data.SemesterLst.at(-1).Scode
                let duration = this.tokenCode.length < 40 ? 30 : 0.1
                if(getCookie('TokenCode') != this.tokenCode) {
                    setCookie('TokenCode', this.tokenCode, duration)
                    setCookie('userCode', this.userCode, duration)
                }
                $('#collapseGuide').collapse('hide')

                this.getAllCriterias()

            } catch(e){
                this.isLoading = false
                this.$loading().close()
                console.error(e)
                this.$toast.error('Có lỗi xảy ra, vui lòng thử lại.')
            }
        },
        getSemester(){
            return this.$axios({
                method: 'post',
                url: 'https://ctsv.hust.edu.vn/api-t/Point/GetSemester',
                headers: this.getHeaders(),
                data: {
                    "TokenCode": this.tokenCode,
                    "UserName": this.userCode
                }
            })
        },
        async getAllCriterias(){
            try{
                let response = await this.$axios({
                        method: 'post',
                        url: 'https://ctsv.hust.edu.vn/api-t/Criteria/GetCriteriaTypeDetails',
                        headers: this.getHeaders(),
                        data: {
                            "Semester": this.semester,
                            "UserCode": this.userCode,
                            "TokenCode": this.tokenCode,
                            "UserName": this.userCode
                        }
                    })
                let critePromises = []
                this.allCriterias = response.data.CriteriaTypeDetailsLst

                this.criterias   = []
                this.activities  = []
                this.choosingAct = {}
                this.sum = 0
                this.hasChange = false
                this.$swal.close()

                this.allCriterias.forEach((element, i0) => {
                    element.CriteriaGroupDetailsLst.forEach((e, i1) => {
                        e.UserCriteriaDetailsLst.forEach(crite => {
                            if(!crite.Proof) return
                            this.criterias.push([crite, i0, i1])
                            critePromises.push(this.getActivityByCid(crite.CId))
                        })
                    })
                })

                let criteResponses = await Promise.all(critePromises)

                let actPromises = []
                criteResponses.forEach(response => {
                    if(!response?.data) return
                    response.data.Activities.forEach(act => {
                        actPromises.push(this.getActivityById(act.AId))
                    })
                })

                let actResponses = await Promise.all(actPromises)
                actResponses.forEach(response => {
                    if(!response?.data) return
                    this.activities.push(response.data.Activities[0])
                })

                this.sortData()
            } catch(e){
                this.isLoading = false
                this.$loading().close()
                console.error(e)
                this.$toast.error('Có lỗi xảy ra, vui lòng thử lại.')
            }
        },
        getActivityByCid(CId){
            return this.$axios({
                method: 'post',
                url: 'https://ctsv.hust.edu.vn/api-t/Activity/GetActivityByCId',
                headers: this.getHeaders(),
                data: {
                    "UserCode": this.userCode,
                    "Signature": "sample string 4",
                    "Search": "", "NumberRow": 30,
                    "CId": CId,
                    "PageNumber": 1,
                    "TokenCode": this.tokenCode,
                    "UserName": this.userCode
                }

            })
        },
        getActivityById(AId){
            for(let i = 0; i < this.activities.length; i++){
                if(this.activities[i].AId == AId) return
            }
            return this.$axios({
                method: 'post',
                url: 'https://ctsv.hust.edu.vn/api-t/Activity/GetActivityById',
                headers: this.getHeaders(),
                data: {
                    "AId": AId,
                    "TokenCode": this.tokenCode,
                    "UserName": this.userCode
                }

            })
        },
		getHeaders() {
			return {
                    'authorization': 'Bearer ' + this.tokenCode,
                }
		},
        sortData(){
            let actKey = {}
            for(let i = 0; i < this.activities.length; i++){ // remove duplicate
                if(!actKey[this.activities[i].AId]){
                    actKey[this.activities[i].AId] = true
                    this.activities[i].CriteriaLst.sort((a, b) => b.CMaxPoint - a.CMaxPoint)
                    continue
                }
                this.activities.splice(i--, 1)
            }
            this.activities.sort((a, b) => { // sort by criterias scarcity and by point
                if(a.CriteriaLst.length  == b.CriteriaLst.length) return b.CriteriaLst[0].CMaxPoint - a.CriteriaLst[0].CMaxPoint
                return a.CriteriaLst.length - b.CriteriaLst.length
            })

            this.allCriterias.forEach(criteGroup => { // recalculate criterias sum
                let CTPointSum = 0
                criteGroup.CriteriaGroupDetailsLst.forEach(criteList => {
                    let CGPointSum = 0
                    criteList.UserCriteriaDetailsLst.forEach(crite => {
                        if(crite.UserCriteriaActivityLst[0]){
                            let actDetail = this.activities.find(a => a.AId == crite.UserCriteriaActivityLst[0].AId)
                            crite.UserCriteriaActivityLst[0] = actDetail
                            if(actDetail) crite.UserCriteriaActivityLst[0].userPoint = crite.CMaxPoint // sometimes cant find the crite's activity in the activities list
                            else {
                                setTimeout(() => { this.$toast.error('Có lỗi xảy ra, vui lòng kiểm tra Error Mesage.') }, 1000)
                                console.error('Cant find this crtieria\'s activity', crite)
                            }
                            CGPointSum += crite.CMaxPoint
                        }
                    })
                    criteList.CGPoint = CGPointSum
                    CTPointSum += CGPointSum

                    criteList.UserCriteriaDetailsLst.sort((a, b) => { // sort by point
                        return b.CMaxPoint - a.CMaxPoint
                    })
                })
                criteGroup.CTPoint = CTPointSum
                this.sum += CTPointSum
            })
            this.isLoading = false
            this.$loading().close()
            this.$toast.success('Đã Xong!')
        },
        canChooseCrite(criteria){
            return !this.isCriteTaken(criteria) && this.chosenActHasCrite(criteria)
        },
		isCriteTaken(criteria) {
			return !!criteria.UserCriteriaActivityLst[0]
		},
		chosenActHasCrite(criteria) {
			return this.choosingAct?.CriteriaLst?.find(crite => crite.CId == criteria.CId)
		},
        chooseCrite(criteria, i){
            if(!this.canChooseCrite(criteria)) return

            let criteGroup = this.allCriterias[i[0]]
            criteGroup.CTPoint += criteria.CMaxPoint
            criteGroup.CriteriaGroupDetailsLst[i[1]].CGPoint += criteria.CMaxPoint
            criteria.UCPoint = criteria.CMaxPoint
            this.sum += criteria.CMaxPoint

            this.choosingAct.userPoint = criteria.CMaxPoint
            criteria.UserCriteriaActivityLst[0] = this.choosingAct
            this.choosingAct = {}
            this.$swal.close()
            this.hasChange = true
            this.$forceUpdate()
        },
        chooseAct(act){
            if(this.choosingAct.AId != act.AId){
                this.choosingAct = act

				$('html, body').animate({
					scrollTop: $("#criterias-container").offset().top
				}, 0);

                this.drawer = false
                return
            }
            this.choosingAct = {}
            this.$swal.close()
        },
        unchooseAct(crite, i){
            let criteGroup = this.allCriterias[i[0]]
            criteGroup.CTPoint -= crite.CMaxPoint
            let criteList = criteGroup.CriteriaGroupDetailsLst[i[1]]
            criteList.CGPoint -= crite.CMaxPoint
            crite.UCPoint = 0
            this.sum -= crite.CMaxPoint

            crite.UserCriteriaActivityLst[0].userPoint = 0
            crite.UserCriteriaActivityLst = []
            this.hasChange = true
            this.$forceUpdate()
        },
        cleanActs(acts, CId){
            let actsModified = false
            acts.forEach(act => {
                for(let i = 0; i < act.CriteriaLst.length; i++){ // go each activity and remove this criteria because it cant be asign any more
                    if(act.CriteriaLst[i].CId == CId){ // activities and criterias are sorted so this will always be the best solution
                        act.CriteriaLst.splice(i, 1)
                        actsModified = true
                        break
                    }
                }
            })

            if(actsModified){
                acts.sort((a, b) => {
                    if(a.CriteriaLst.length == 0) return 1
                    if(b.CriteriaLst.length == 0) return -1

                    if(a.CriteriaLst.length == b.CriteriaLst.length){
                        return b.CriteriaLst[0].CMaxPoint - a.CriteriaLst[0].CMaxPoint
                    }

                    return a.CriteriaLst.length - b.CriteriaLst.length
                })
                //actIndex = -1
            }
            return actsModified
        },
        autoPut(){
            if(this.activities.length == 0) return this.$toast.warning('Bạn không có hoạt động nào để chấm.')
            this.criterias.forEach(crite => {
                if(crite[0].UserCriteriaActivityLst[0]){
                    this.unchooseAct(crite[0], [crite[1], crite[2]])
                }
            })

            let acts = JSON.parse(JSON.stringify(this.activities)) // deep copy
            for(let actIndex = 0; actIndex < acts.length; actIndex++){
                this.choosingAct = this.activities.find(val => !val.userPoint && val.AId == acts[actIndex].AId) ?? {} // find in activities becasue acts element order is different
                let actCrite0 = acts[actIndex].CriteriaLst[0]
                if(!actCrite0 || Object.keys(this.choosingAct).length == 0) continue

                this.criterias.forEach(criteInfo => { // find each criteria
                    let criteGroup = this.allCriterias[criteInfo[1]]
                    let criteList  = criteGroup.CriteriaGroupDetailsLst[criteInfo[2]]
                    let crite = criteInfo[0]

                    if(!crite.UserCriteriaActivityLst[0] && actCrite0.CId == crite.CId){ // if have not asign and can be asign by current activity
                        if(crite.CMaxPoint + criteGroup.CTPoint > criteGroup.CTMaxPoint) return
                        if(crite.CMaxPoint + criteList.CGPoint > criteList.CGMaxPoint) return

                        this.chooseCrite(crite, [criteInfo[1], criteInfo[2]])
                        if(this.cleanActs(acts, crite.CId)) actIndex = -1
                    }
                })
            }

            let hasOverflow = false
            for(let actIndex = 0; actIndex < acts.length; actIndex++){ // put leftovers, even when overflow
                let currentAct = acts[actIndex]
                this.choosingAct = this.activities.find(val => !val.userPoint && val.AId == currentAct.AId) ?? {}
                if(Object.keys(this.choosingAct).length == 0) continue
                let criteOverflow = []

                for(let criteIndex = 0; criteIndex < currentAct.CriteriaLst.length; criteIndex++){
                    let actCriteI = currentAct.CriteriaLst[criteIndex]

                    this.criterias.forEach(criteInfo => {
                        let criteGroup = this.allCriterias[criteInfo[1]]
                        let criteList  = criteGroup.CriteriaGroupDetailsLst[criteInfo[2]]
                        let crite = criteInfo[0]

                        if(!crite.UserCriteriaActivityLst[0] && actCriteI.CId == crite.CId){
                            let o1 = actCriteI.CMaxPoint + criteList.CGPoint - criteList.CGMaxPoint
                            let o2 = actCriteI.CMaxPoint + criteGroup.CTPoint - criteGroup.CTMaxPoint
                            let overflow = 0
                            if(o1 > 0) overflow = o1
                            if(o2 > 0 && o2 > overflow) overflow = o2

                            criteOverflow.push([...criteInfo, overflow])
                        }
                    })
                }

                let bestCrite = criteOverflow.reduce((best, curr) => curr[3] < best[3] ? curr : best, criteOverflow[0])
                if(bestCrite){
                    this.chooseCrite(bestCrite[0], [bestCrite[1], bestCrite[2]])
                    hasOverflow = true
                    if(this.cleanActs(acts, bestCrite[0].CId)) actIndex = -1
                }
            }
            if(hasOverflow) setTimeout(() => this.$toast.error('Có Tiêu chí vượt quá Điểm tối đa. Xin hãy lưu ý.', { timer: 5000 }), 2000)
            this.$toast.success('Đã tự động chấm xong.')
        },
        bruteforcePut(){
            if(this.activities.length == 0) return this.$toast.warning('Bạn không có hoạt động nào để chấm.')
            this.$loading()
            this.criterias.forEach(crite => {
                if(crite[0].UserCriteriaActivityLst[0]){
                    this.unchooseAct(crite[0], [crite[1], crite[2]])
                }
            })

            setTimeout(() => {
                let acts = JSON.parse(JSON.stringify(this.activities)) // deep copy

                this.sum = 0
                this.tryPut(acts, 0, 0, false)

                acts = JSON.parse(this.actsSnapshot)
                this.allCriterias = JSON.parse(this.allCriteriasSnapshot)
                this.criterias = []
                this.allCriterias.forEach((element, i0) => {
                    element.CriteriaGroupDetailsLst.forEach((e, i1) => {
                        e.UserCriteriaDetailsLst.forEach(crite => {
                            if(!crite.Proof) return
                            this.criterias.push([crite, i0, i1])
                        })
                    })
                })

                let sumBefore = this.sum
                this.tryPut(acts, 0, this.sum, true)

                this.allCriterias = JSON.parse(this.allCriteriasSnapshot)
                this.criterias = []
                this.allCriterias.forEach((element, i0) => {
                    element.CriteriaGroupDetailsLst.forEach((e, i1) => {
                        e.UserCriteriaDetailsLst.forEach(crite => {
                            if(!crite.Proof) return
                            this.criterias.push([crite, i0, i1])
                            let act = crite.UserCriteriaActivityLst[0]
                            if(act) {
                                crite.UserCriteriaActivityLst[0] = this.activities.find(val => act.AId == val.AId) // same value but different object
                                crite.UserCriteriaActivityLst[0].userPoint = crite.CMaxPoint
                            }
                        })
                    })
                })

                this.$loading().close()
                if(this.sum - sumBefore > 0) setTimeout(() => this.$toast.error('Có Tiêu chí vượt quá Điểm tối đa. Xin hãy lưu ý.', { timer: 5000 }), 2000)
                this.$toast.success('Đã tự động chấm xong.')
            }, 100)
        },
        tryPut(acts, actIndex, sum, allowOverflow){
            if(actIndex == acts.length) {
                if(sum > this.sum) {
                    this.sum = sum
                    this.allCriteriasSnapshot = JSON.stringify(this.allCriterias)
                    this.actsSnapshot = JSON.stringify(acts)
                }
                return
            }
            if((acts.length - actIndex - 1) * 8 + sum < this.sum) { // cut branch
                return
            }

            let currentAct = acts[actIndex]
            this.tryPut(acts, actIndex + 1, sum, allowOverflow)
            if(allowOverflow && currentAct.userPoint != 0) return

            for(let criteIndex = 0; criteIndex < currentAct.CriteriaLst.length; criteIndex++){
                let actCriteI = currentAct.CriteriaLst[criteIndex]
                this.criterias.forEach(criteInfo => { // find each criteria 
                    let criteGroup = this.allCriterias[criteInfo[1]]
                    let criteList  = criteGroup.CriteriaGroupDetailsLst[criteInfo[2]]
                    let crite = criteInfo[0]

                    if(!crite.UserCriteriaActivityLst[0] && actCriteI.CId == crite.CId){ // if have not asign and can be asign by current activity
                        if(!allowOverflow) {
                            if(crite.CMaxPoint + criteGroup.CTPoint > criteGroup.CTMaxPoint) return
                            if(crite.CMaxPoint + criteList.CGPoint > criteList.CGMaxPoint) return
                        }

                        criteGroup.CTPoint += crite.CMaxPoint
                        criteList.CGPoint += crite.CMaxPoint
                        crite.UCPoint = crite.CMaxPoint

                        crite.UserCriteriaActivityLst[0] = currentAct
                        currentAct.userPoint = crite.CMaxPoint
                        this.tryPut(acts, actIndex + 1, sum + crite.CMaxPoint, allowOverflow)
                        currentAct.userPoint = 0
                        crite.UserCriteriaActivityLst = []

                        criteGroup.CTPoint -= crite.CMaxPoint
                        criteList.CGPoint -= crite.CMaxPoint
                        crite.UCPoint = 0
                    }
                })
            }
        },
        submit(){
            this.$axios({
                method: 'post',
                url: 'https://ctsv.hust.edu.vn/api-t/Point/MarkCriteriaUser',
                headers: this.getHeaders(),
                data: {
                    "CriteriaTypeDetailsLst": this.allCriterias,
                    "TokenCode": this.tokenCode,
                    "UserName": this.userCode,
                    "UserCode": this.userCode,
                    "Semester": this.semester,
                }
            }).then(response => {
                if(response.data.RespCode == 0){
                    this.hasChange = false
                    this.$toast.success('Lưu thành công!')
                }
                else this.$toast.error(response.data.RespText)
            }).catch(e => {
                console.error(e)
                this.$toast.error('Có lỗi xảy ra, vui lòng thử lại.')
            })
        },
        dataFetched () {
            return this.allCriterias.length > 0
        },
        tooltipEnter(tooltipName, timeout = 400) {
            this.tooltipTimeout[tooltipName] = setTimeout(() => {
                this.tooltip[tooltipName] = true
            }, timeout)
        },
        tooltipLeave(tooltipName) {
            this.tooltip[tooltipName] = false
            if(this.tooltipTimeout[tooltipName]) clearTimeout(this.tooltipTimeout[tooltipName])
            this.tooltipTimeout[tooltipName] = null
        },
		hasHoveringAct(criteria) {
			return !!this.hoveringAct?.CriteriaLst?.find(crite => crite.CId == criteria.CId)
		}
    },
    async created(){
        let token = getCookie('TokenCode')
        if(token != ''){
            this.tokenCode = token
            this.userCode = getCookie('userCode')
        }
    },
    destroyed(){
        this.$swal.close()
    },
}
</script>

<style scoped>
    .submit{
        position: fixed;
        right: 50px;
        bottom: 50px;
    }
    .drawer-button {
        position: fixed;
        top: 50%;
        left: 10px;
        width:30px;
        height:30px;
        border-radius: 100%;
    }
    .activity-panel {
        min-height: 40px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        background-color: #fafafa;
        cursor: pointer;
        box-shadow: 0 1px 0 #091e4240;
        margin-bottom: 8px;
        white-space: nowrap;
    }
    .activity-panel:hover {
        box-shadow: 0px 0px 12px 0 rgba(0, 0, 0, .25) inset;
    }
    .activity-panel.active {
        background: #d8d5e082;
    }
	.text-secondary.text-success:not(.text-warning) {
		color: #28a7459e !important;
	}
	.blinking {
        animation: blink 2s linear infinite;
	}
	@keyframes blink {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
			color: orange;
		}
		100% {
			opacity: 0;
		}
	}
</style>